export class Packages {
    static async getPresets(storeUuid, integrationCode) {
        return await axios.get(route('ajax.stores.package-dimension-presets', {
            storeUuid: storeUuid,
            integration_code: integrationCode
        }));
    }
}
